<template>
    <div>
        <el-card class="search-form-card">
            <el-form :model="form" class="search-form" label-width="90px" inline="true">
                <el-form-item label="选择类别:">
                    <el-select v-model="form.type" placeholder="请选择" @change="selectChangeEvent" class="common-input">
                      <el-option v-for="(item,index) in dictionariesSelect" :label="item.cname" :value="item.ename" :key="index"></el-option>
                      <!-- <el-option label="项目" value="beijing"></el-option> -->
                    </el-select>
                </el-form-item><br/>
                <el-form-item :label='formLabel+"中文名称:"'>
                    <el-input v-model="form.cname" @keyup.enter.native="request" class="common-input"></el-input>
                </el-form-item>
                <el-form-item :label='formLabel+"英文名称:"'>
                    <el-input v-model="form.ename" @keyup.enter.native="request" class="common-input"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="loadData">搜索</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-card>
            <div slot="header">
                <router-link  :to="{ path:'/optionCustomAdd',query: {dictType:form.type,label:formLabel, callback:request } }">
                    <el-button type="primary" >新增</el-button>
                    <!--v-w-role="'ITSM-0079'"-->
                </router-link>

            </div>
            <el-table :data="tableData" v-loading="loading">
                <el-table-column label="序号" prop="id"></el-table-column>
                <el-table-column :label="formLabel+'中文名称'" prop="cname" ></el-table-column>
                <el-table-column :label="formLabel+'英文名称'" prop="ename" ></el-table-column>
                <el-table-column v-if="form.type == 'project_name'" label="ONES项目名称" prop="ones_project_name"></el-table-column>
                <el-table-column v-if="form.type == 'project_name'" label="关联二线" prop="related_user_name"></el-table-column>
                <el-table-column v-if="form.type == 'project_name'" label="关联cab组" prop="cab_group_name"></el-table-column>
                <el-table-column label="创建时间" prop="create_time"></el-table-column>
                <el-table-column label="修改时间" prop="update_time"></el-table-column>
                <!-- <el-table-column label="IP" prop="ip"></el-table-column>

                <el-table-column label="个人信息">
                    <template slot-scope="scope">
                        <router-link :to="{path:'/onlineUsersView',query:{internalUserid:scope.row.user}}">
                            <el-button type="text" >查看详细</el-button>
                        </router-link>
                    </template>
                </el-table-column> -->
                <el-table-column label="操作" fixed="right" min-width="120">
                    <!-- <template slot-scope="scope">
                        <el-button v-w-role="" class="table-del-btn" type="text" @click="forceOfflineUser(scope.row.user,scope.row.name)">强制下线</el-button>
                    </template> -->
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/optionCustomAdd',
                        query: { type:'edit',id:scope.row.id,dictType:scope.row.type,cname:scope.row.cname,ename:scope.row.ename,
                        label:formLabel,
                        relatedId:scope.row.related_user_id,
                        cabGroupID:scope.row.cab_group_id,
                        onesProjectId:scope.row.ones_project_id,
                        callback:request }}">
                            <el-button type="text" v-w-role="'ITSM-0120-1'">编辑</el-button>
                        </router-link>
                        <el-button v-w-role="'ITSM-0120-2'" class="table-del-btn" type="text" @click="deleteEvent(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.page"
                           :page-sizes="[10,20]"
                           :page-size="form.per_page"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
    // import { statusLists } from "./event.config";
    import services from "./system.service";
    import commonService from "../../services/common.service";
    export default {
        data() {
            return {
                form:{
                    type:'',
                    cname:'',
                    ename:'',
                    per_page:10,
                    page:1,
                },
                total:null,
                dictionariesSelect:null,
                tableData:[],
                loading:false,
                formLabel:''
            }
        },
        watch:{
            'form.type':{//深度监听，可监听到对象、数组的变化
                 handler(val, oldVal){
                     if(val !== oldVal){
                        this.loadData();
                     }
                 },
                 deep:true //true 深度监听
            }
        },
        created() {
            this.getDictionariesEditData()
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
        },
        methods: {

            loadData(){
                this.form.page = 1;
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                this.request();
            },
            getDictionariesEditData(){
                // 获取列表数据
                services.getDataDictionariesEdit(this.form).then(res => {
                    this.form.type = res[0].ename
                    this.formLabel = res[0].cname
                    this.dictionariesSelect = res

                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            request(){
                if(this.form.type !== ''){
                // 获取列表数据
                services.getOptionCustomList(this.form).then(res => {
                    this.tableData = res.list;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
                }
            },
            deleteEvent(id){
                this.$confirm('确定要删除此条数据吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    services.getOptionCustomDel({id:id}).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.loadData()
                    }).catch(err => {
                        this.$message.error(err.message);
                    })

                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消删除'
                  });
                });

            },
            forceOfflineUser(userid,name){
                this.openMessage(`确定要将'${name}'用户强制下线吗？`, '确定', () => {
                    let currentUser=window.localStorage.getItem('name')
                    let params={
                        currentUser,
                        username:userid
                    }
                    services.forceOffline(params).then(res => {
                        this.$message.success("强制下线成功");
                        this.request();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.per_page = val;
                if(this.form.page > pages ){
                    this.form.page  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.page = val;
                this.request();
            },
            selectChangeEvent(val){
                this.dictionariesSelect.map(item => {
                    if(item.ename == val){
                        this.formLabel = item.cname
                    }
                })
                console.log(val)
            }

        },
        mounted(){

            this.request();
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
